module.exports = __webpack_public_path__ + "93c48a7f33c1b6ae60f488a81317443d.png";